import styled from 'styled-components';

const Paragraph = styled.p`
  white-space: pre-line;
  word-wrap: break-word;
`;

export default Paragraph;
